import * as React from 'react';
import leftImageDesk from '../../assets/Img/desktop/1_prestito_sx.jpg';
import rightImageDesk from '../../assets/Img/desktop/1_prestito_dx.jpg';
import leftImageMob from '../../assets/Img/mobile/1_prestito_sx.jpg';
import rightImageMob from '../../assets/Img/mobile/1_prestito_dx.jpg';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import { Slider } from '../Slider';
import { isMobile, mediaQueries } from '../../mediaQueries';
import { colors } from '../../colors';
import Sticky from '../sticky/Sticky';
import { CTA } from '../Cta';
import * as Scroll from 'react-scroll';
import { ArrowDown } from '../ArrowDown';
import useResizeAware from 'react-resize-aware';
import { useInView } from 'react-intersection-observer';
import mobileIcon from '../../assets/Icons/smartphone_icon.svg';
import { ArrowNext } from '../ArrowNext';

interface IProps {
    height?: number;
    stickyHeight?: number;
    onNextClickScroll?: string;
    trackingCluster: string;
}

// const offsetAnimation = 500;

export const Prestito = ({ height, stickyHeight, onNextClickScroll, trackingCluster }: IProps) => {

    const isMob = isMobile();
    const isSmallScreen = mediaQueries.isSmallScreen();
    const [isSticky, setIsSticky] = React.useState(false);
    const [isEntered, setIsEntered] = React.useState(false);
    const [isCompleting, setIsCompleting] = React.useState(false);

    const { ref, inView, entry } = useInView({
        threshold: [0.4, 0.7],
    });

    // const exiting = useInView({
    //     threshold: 0.8,
    // });

    React.useEffect(() => {
        // console.info('entry', entry);
        setIsEntered(entry && (entry.intersectionRatio > 0.4 && entry.intersectionRect.top > 0 || entry.boundingClientRect.top < 0))
        setIsCompleting(entry && (entry.intersectionRatio > 0.7 && entry.intersectionRect.top > 0 || entry.boundingClientRect.top < 0))
        // setIsEntered(entry && entry.isIntersecting)
    }, [entry])

    // const [percentage, setPercentage] = React.useState(0);

    const leftImage = isMob || isSmallScreen ? leftImageMob : leftImageDesk;
    const rightImage = isMob || isSmallScreen ? rightImageMob : rightImageDesk;
    const pageH = height - stickyHeight;

    const [resizeListener, contentHeaderSizes] = useResizeAware();

    const onStickyChange = (v: boolean) => {
        // console.info('onStickyChange', v);
        setIsSticky(v);
    }

    const onArrowClick = () => {

        Scroll.scroller.scrollTo('prestito-scroll-content', {
            duration: 1000,
            delay: 50,
            smooth: true,
            offset: -(stickyHeight)
        });
    }

    const onNextArrowClick = () => {

        Scroll.scroller.scrollTo(onNextClickScroll, {
            duration: 1000,
            delay: 50,
            smooth: true,
        });
    }

    return <div className={`page-container ${isSticky ? "sticky" : "non-sticky"} ${isEntered ? "inside-view" : "outside-view"} ${isCompleting ? "completing-view" : ""}`}>
        <Scroll.Element name="prestito-scroll" />
        <Sticky offsetTop={stickyHeight} zIndex={3} onChange={onStickyChange}>
            <div className="comparer-container" style={{ height: pageH, position: 'relative', zIndex: 4 }}>
                <ReactCompareSlider
                    onlyHandleDraggable={true}
                    handle={<Slider pageH={pageH} />}
                    itemOne={<ReactCompareSliderImage src={leftImage} className="compare-slider-image" style={{ maxHeight: pageH }} alt="Automobile" />}
                    itemTwo={<ReactCompareSliderImage src={rightImage} className="compare-slider-image" style={{ maxHeight: pageH }} alt="Automobile" />}
                />

            </div>
        </Sticky>
        <div ref={ref} className='page-text-content' style={{ marginTop: -contentHeaderSizes.height + stickyHeight, zIndex: 4, height: pageH }}>
            <div className="block start">
                <div className="centered">
                    {resizeListener}
                    <ArrowDown color="white" onClick={onArrowClick} />
                    <Scroll.Element name="prestito-scroll-content" />
                    <h2 className="upper"> Cambiare la tua automobile utilizzando solo il tuo <i>mobile</i>. <img className="mobile-icon" src={mobileIcon} /></h2>
                    <span className="red-line" />
                </div>


            </div>
            <div className="block ">
                <p>Con Santander puoi richiedere un prestito personale per la tua auto
                nuova, usata o per qualsiasi cosa tu voglia acquistare, ovunque tu sia, in
ogni momento: 100% online, 0% spreco di carta. </p>
            </div>
            <div className="block">
                <CTA gaLabel="PP" trackingCluster={trackingCluster} trackingAction="click_PP" text={'CALCOLA LA RATA'} href="/prestito/santander" />
                <p className="small light">Annuncio pubblicitario con finalità promozionale. Per le condizioni contrattuali ed economiche del finanziamento consultare le "Informazioni europee di base sul credito ai consumatori" disponibili sul sito nella sezione <a href="/area-trasparenza" target="_blank">Trasparenza</a>.<br />Salvo approvazione Santander Consumer Bank.</p>
            </div>
        </div>

        {onNextClickScroll && <ArrowNext onClick={onNextArrowClick} />}

    </div>
}